import moment, { Moment } from "moment";
import * as zDate from "./date";
import { isFunction } from "./util";

export function dateToUTC(date, dateTime?) {
    var now;

    if (date == null) {
        now = new Date();
    } else {
        now = new Date(date);
    }

    if (!dateTime) {
        return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    } else {
        return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes());
    }
}

/*
* AddMinutes
* Takes in a date and adds the amount of minutes to it
*
* date - any data object passed in
* minutes - minutes you wish to add to date passed in
*
*/
export function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}

/*
* AddHours
* Takes in a date and adds the amount of minutes to it
*
* date - any data object passed in
* minutes - minutes you wish to add to date passed in
*
*/
export function addHours(date, hours) {
    var newDate = new Date(date);
    newDate.setHours(date.getHours() + hours);
    return newDate;
}

export function addDays(dateString, days) {
    // Expects and returns a string with the format "YYYY-MM-DDT00:00:00Z"
    var date = dateToUTC(dateString);
    date.addDays(days);
    return kendo.toString(date, "yyyy-MM-dd") + "T00:00:00Z";
}

export function subtractDays(dateString, days) {
    // Expects and returns a string with the format "YYYY-MM-DDT00:00:00Z"
    var date = dateToUTC(dateString);
    date.subtractDays(days);
    return kendo.toString(date, "yyyy-MM-dd") + "T00:00:00Z";
}

export function addMonths(dateString, months) {
    // Expects and returns a string with the format "YYYY-MM-DDT00:00:00Z"
    // Works like .NET AddMonths or SQL Server DATEADD(mm, ...) where March 31st + 1 month = April 30th, not May 1.
    var date = dateToUTC(dateString);

    var dayOfMonth = date.getDate();
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    // TODO: getYear() is deprecated. Fix.
    var daysInMonth = new Date((date as any).getYear(), date.getMonth() + 1, 0).getDate(); // day 0 of next month == last day of this month
    date.setDate(Math.min(dayOfMonth, daysInMonth));

    return kendo.toString(date, "yyyy-MM-dd") + "T00:00:00Z";
}

/*
* zeroPad
* Takes in a string and 0 pads it
*
* string - string you want padded
* length - length of the output string you want
*
*/
export function zeroPad(str, length) {
    if (str != null && length) {
        str = str.toString();
        var output = str;
        for (var ii = str.length; ii < length; ii++) {
            output = "0" + output;
        }
        return output;
    }
    return "";
}

export function buildDateString(value, offsetHandled?) {
    var newValue: any = "";

    if (offsetHandled == undefined || offsetHandled == null) {
        offsetHandled = false;
    }

    if (typeof value == "string") {
        value = new Date(value);
    }

    if (Object.prototype.toString.call(value) === "[object Date]") {
        // it is a date
        if (isNaN(value.getTime())) { // value.valueOf() could also work
            // date is invalid
            newValue = "";
        } else {
            // date is valid
            newValue = new Date(value.getTime());

            if (!offsetHandled) {
                var offset = newValue.getTimezoneOffset() / 60;
                newValue = newValue.addHours(offset);
            }

            var month = zeroPad(newValue.getMonth() + 1, 2),
                day = zeroPad(newValue.getDate(), 2),
                year = newValue.getFullYear();

            newValue = month + "/" + day + "/" + year.toString().substring(2, 4);
        }
    } else {
        // not a date
        newValue = "";
    }

    return newValue;
}

export function buildDateTimeString(value) {
    var newValue: any = "";
    if (typeof value == "string") {
        value = zDate.date(value);
    }

    if (Object.prototype.toString.call(value) === "[object Date]") {
        // it is a date
        if (isNaN(value.getTime())) { // value.valueOf() could also work
            // date is invalid
            newValue = "";
        } else {
            // date is valid
            newValue = new Date(value.getTime());

            var month = zeroPad(newValue.getMonth() + 1, 2),
                day = zeroPad(newValue.getDate(), 2),
                year = zeroPad(newValue.getFullYear(), 2).substring(2),
                hour = newValue.getHours(),
                minute = zeroPad(newValue.getMinutes(), 2),
                tt;

            year = zeroPad(year, 2);

            if (hour < 12) {
                tt = "AM";
            } else {
                tt = "PM";
            }
            if (hour == 0) {
                hour = 12;
            }
            if (hour > 12) {
                hour = hour - 12;
            }

            hour = zeroPad(hour, 2);

            newValue = month + "/" + day + "/" + year + " " + hour + ":" + minute + " " + tt;
        }
    } else {
        // not a date
        newValue = "";
    }

    return newValue;
}

export function buildTimeString(date) {
    if (typeof date == "string") {
        date = zDate.date(date);
    }
    if (date) {
        var seconds = date.getSeconds() + date.getMinutes() * 60 + date.getHours() * 3600;

        seconds = seconds || 0;
        seconds = Math.floor(seconds);

        var min = Math.floor(seconds / 60) % 60;
        var hour = Math.floor(seconds / 3600);
        var ampmString = (hour < 12 ? "AM" : "PM");

        if (hour > 12) {
            hour = hour - 12;
        }
        var convertedHour = hour == 0 ? 12 : hour;

        return zeroPad(convertedHour, 2) + ":" + zeroPad(min, 2) + " " + ampmString;
    }
    return "";
}

export function buildDurationString(args) {
    args = args || {};

    var sec = Math.floor(args.seconds % 60);
    var min = Math.floor(args.seconds / 60) % 60;
    var hour = Math.floor(args.seconds / 3600);

    if (args.dur) {
        return zeroPad(hour, 2) + " hrs : " + zeroPad(min, 2) + " mins : " + zeroPad(sec, 2) + " secs";
    }
    if (args.justNumbers) {
        return zeroPad(hour, 2) + ":" + zeroPad(min, 2) + ":" + zeroPad(sec, 2);
    }
    return "";
}

export function buildUTCString(date) {
    var dateObject = date;
    if (typeof date == "string") {
        dateObject = zDate.date(date);
    }

    // Might be a time
    if (isNaN(dateObject.getTime())) {
        dateObject = zDate.date("1/1/1970 " + date);
    }

    return dateObject.toISOString();
}

export function kendoFormatDate(value) {
    if (!value) {
        return "";
    }

    if (typeof value != "string") {
        if (!value.getDate || !isFunction(value.getDate) || isNaN(value.getDate())) {
            return "";
        }

        value = value.toISOString();
    }

    value = value.substring(0, 10);
    var date = moment(value);
    return kendo.toString(date.toDate(), kendo.culture().calendar.patterns.d);
}

export function kendoFormatDateTime(value) {
    if (!value) {
        return "";
    }
    var dateTime = moment(value);
    return kendo.toString(dateTime.toDate(), kendo.culture().calendar.patterns.g);
}

export function kendoFormatTime(value) {
    if (!value) {
        return "";
    }
    var time = moment(value);
    return kendo.toString(time.toDate(), kendo.culture().calendar.patterns.t);
}

export function kendoFormatAbsoluteTime(value) {
    if (!value) {
        return "";
    }
    var time = moment(value);
    var theDate = time.toDate();
    theDate.setFullYear(1970, 0, 1);
    theDate.setHours(value.substring(11, 13));
    theDate.setMinutes(value.substring(14, 16));
    return kendo.toString(theDate, kendo.culture().calendar.patterns.t);
}

export function convertKendoTimeFormatToMoment(str) {
    // Kendo indicates AM/PM in their format string with 'tt' whereas moment indicates with an 'a'
    return str.replace("tt", "a");
}

export function formatDurationFromHours(hours) {
    if (hours === null || hours === undefined) {
        return "---";
    }

    var minutes = Math.round(hours * 60);
    var hr = Math.floor(minutes / 60);
    var min = minutes % 60;

    if (min == 0) {
        return "{0} hr".format(hr.toString());
    } else {
        return "{0} hr {1} min".format(hr.toString(), min.toString());
    }
}

export function roundUpToNextUtcDate(d: Date): Date {
    const dayInMilliseconds = 24 * 60 * 60 * 1000;

    return new Date(Math.trunc((d.getTime() + dayInMilliseconds) / dayInMilliseconds) * dayInMilliseconds);
}

const secondsPerHour = 60 * 60;

export const hoursBetweenDateTimes = (start: Moment | Date | string, end: Moment | Date | string) => {
    if (!start || !end) {
        return null;
    }
    const seconds = (moment(end).diff(moment(start), "seconds"));
    return (seconds / secondsPerHour);
}